<template>
    <div class="video">
        <div class="audioInfo" v-if="audio">
            <div>{{ title }}</div>
            <div v-if="!playing">点击开始播放</div>
        </div>
        <audio ref="audio" v-if="audio" :src="src" @play="onPlay" @pause="onPause" @ended="onEnd" @timeupdate="onTimeUpdate" @waiting="onWaiting" @loadedmetadata="onloadedmetadata"></audio>
        <video ref="video" v-else :src="src" poster="static/poster-1.gif" x5-playsinline x-webkit-airplay webkit-playsinline playsinline @play="onPlay" @pause="onPause" @ended="onEnd" @timeupdate="onTimeUpdate" @waiting="onWaiting" @loadedmetadata="onloadedmetadata"></video>
        <div class="mask" @click="toPlay" v-if="!playing || waiting">
            <mt-spinner v-if="waiting"></mt-spinner>
            <i href="javascript:;" class="music icon icon-play-o" v-else></i>
        </div>
        <div class="control" v-if="!first">
            <a href="javascript:;" class="icon icon-pause" v-if="playing" @click="toPause"></a>
            <a href="javascript:;" class="icon icon-play1" v-else @click="toPlay"></a>
            <span>{{ currentTime | secondTime }}</span>
            <a ref="track" href="javascript:;" class="track">
                <a href="javascript:;" class="thumb" :style="style" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
                    <span></span>
                </a>
            </a>
            <span>{{ duration | secondTime }}</span>
            <a href="javascript:;" class="icon icon-fullscreen" v-if="!audio" @click="toFullScreen"></a>
        </div>
        <div class="debug" v-if="debug">{{ fps }}</div>
    </div>
</template>
<script>
const n = n => n < 10 ? '0' + n : n
import { Spinner } from 'mint-ui';

function formatedUrl(url) {
    url = url.replace(/https?:\/\/.*?\//, "");
    var i = url.lastIndexOf("?");
    if (i > 0) {
        url = url.substr(0, i);
    }
    return url;
}

export default {
    components: { 'mt-spinner': Spinner },
    props: {
        movie: {}
    },
    data() {
        return {
            audio: false,
            playing: false,
            time: 0,
            duration: 0,
            currentTime: 0,
            touching: false,
            waiting: false,
            title: '',
            src: '',
            first: true,
            fps: '无加速'
        }
    },
    computed: {
        player() {
            if (this.audio) {
                return this.$refs.audio
            } else {
                return this.$refs.video
            }
        },
        progress() {
            return this.currentTime / this.duration
        },
        style() {
            return {
                left: (this.progress * 100) + '%'
            }
        },
        debug() {
            return window.query.debug
        }
    },
    filters: {
        secondTime(seconds) {
            let minutes = parseInt(seconds / 60)
            seconds = seconds % 60
            if (minutes < 60) {
                return `${n(minutes)}:${n(seconds)}`
            } else {
                let hours = parseInt(minutes / 60)
                minutes = minutes % 60
                return `${hours}:${n(minutes)}:${n(seconds)}`
            }
        }
    },
    beforeDestroy() {
        if (this.hls) {
            this.hls.destroy()
        }
    },
    methods: {
        play(resource, auto, audio) {
            if (this.hls) {
                this.hls.destroy()
                this.hls = null;
            }
            this.audio = audio
            this.time = 0
            this.title = resource.title
            this.src = audio ? resource.url_5 : resource.url_1;
            this.channel_id = resource.url_1;
            this.channelid_prefix = Math.random() * Date.now() + '';
            this.ws_signaler = 'wss://signal.p2p.cnfuyin.com';
            this.db_cdn = false;
            this.rewrite_segment_id = 0;
            if (resource.server && !audio) {
                if (resource.server.db_cdn == 'cdnbye') {
                    this.db_cdn = true;
                    this.src = resource.server.cdn_mp4db_url;
                    this.channel_id = resource.server.channel_id;
                    this.channelid_prefix = resource.server.channelid_prefix;
                    this.ws_signaler = resource.server.ws_signaler;
                    this.rewrite_segment_id = resource.server.rewrite_segment_id;
                }
            }
            if (audio || !this.first) {
                this.$nextTick(this.toPlay)
            }
        },
        toPlay() {
            this.player.play()
            this.onWaiting()
        },
        toPause() {
            this.player.pause()
        },
        toFullScreen() {
            if (this.player.webkitEnterFullScreen) {
                this.player.webkitEnterFullScreen()
            } else if (this.player.requestFullscreen) {
                this.player.requestFullscreen()
            } else if (this.player.webkitRequestFullscreen) {
                this.player.webkitRequestFullscreen()
            } else if (this.player.webkitRequestFullScreen) {
                this.player.webkitRequestFullScreen()
            }
        },
        onPlay() {
            this.playing = true
            this.first = false
        },
        onPause() {
            this.playing = false
        },
        onEnd() {
            if (window.isIOS) {
                this.$emit('end')
            } else {
                this.player.play()
                this.$nextTick(() => {
                    this.player.pause()
                    this.$emit('end')
                })
            }
        },
        onTimeUpdate() {
            this.playing = !this.player.paused
            this.waiting = false
            if (this.touching) {
                return
            }
            this.duration = parseInt(this.player.duration)
            this.currentTime = parseInt(this.player.currentTime)
        },
        onWaiting() {
            this.waiting = true
        },
        onloadedmetadata() {
            this.duration = parseInt(this.player.duration)
        },
        onTouchStart(e) {
            this.touching = true
            this.from = e.changedTouches[0].clientX
            this.last = this.progress
        },
        onTouchMove(e) {
            if (this.touching) {
                let width = this.$refs.track.clientWidth
                let offset = e.changedTouches[0].clientX - this.from
                let left = offset / width + this.last
                if (left < 0) {
                    left = 0
                } else if (left > 1) {
                    left = 1
                }
                this.currentTime = parseInt(this.duration * left)
            }
        },
        onTouchEnd(e) {
            if (this.touching) {
                this.player.currentTime = this.currentTime
            }
            this.touching = false
        }
    }
}
</script>
<style scoped lang='scss'>
.video {
    position: relative;
    height: 100%;
    background-color: $color-black;

    .debug {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        transform: translate(0, 100%);
        background-color: white;
        z-index: 999;
        color: #13227a;
        padding: 10px;
        white-space: pre-wrap;
    }

    video {
        width: 100%;
        height: 100%;
        background-color: $color-black;
    }

    .audioInfo {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        color: $color-white;
        text-align: center;
        padding: 50px 40px 0 40px;

        > div {
            &:first-child {
                height: 80px;
            }

            &:nth-child(2) {
                font-size: 18px;
            }
        }
    }

    .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;

        > i {
            font-size: 48px;
            color: $color-white;
        }
    }

    .control {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 40px;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        color: $color-white;

        > span {
            width: 60px;
            text-align: center;
        }

        .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
        }

        .track {
            position: relative;
            flex: 1;
            background-color: rgba(255, 255, 255, 0.6);
            height: 2px;

            .thumb {
                position: absolute;
                top: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                transform: translate(-50%, -50%);

                span {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background-color: $color-white;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// MovieVideo.vue?533c7655